import React from 'react';
import T from 'prop-types';
// redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import { setActiveNote } from '../../../redux/reducers/journals';
import { openModal } from '../../../redux/reducers/modal';
// hoc
import withSizes from 'react-sizes';
// components
import ShrinkedText from '../../../components/ShrinkedText/ShrinkedText';
// utils
import moment from 'moment';
// styles
import styles from './NoteBlock.mod.css';
import classnames from 'classnames/bind';

let cx = classnames.bind(styles);

const NoteBlock = ({
  note,
  activeNote,
  isTablet,
  openModal,
  setActiveNote,
  userColor,
  ...otherProps
}) => {
  const { id, title, content, type = 'myJournal' } = note;
  const isActive = activeNote && activeNote.id === id;
  const handleClick = () => {
    isTablet && openModal('FULL_NOTE_BLOCK');
    setActiveNote({ id, type });
  };
  return (
    <div className={cx('wrapper')}>
      <div
        className={cx('container', 'hint--bottom', { active: isActive })}
        style={{ borderColor: userColor }}
        onClick={handleClick}
        data-hint="Click to see full note"
        {...otherProps}
      >
        <div className={cx('heading')}>
          <ShrinkedText length={24} className={cx('title')}>
            {title}
          </ShrinkedText>
          <span className={cx('date')}>
            {note.created_at && moment(note.created_at).format('DD/MM/YYYY ')}
            <span className={cx('time')}>
              {note.created_at && moment(note.created_at).format('h:mm')}
            </span>
          </span>
        </div>
        {typeof content === 'string' ? (
          <ShrinkedText length={isTablet ? 50 : 80} className={cx('text')}>
            {content}
          </ShrinkedText>
        ) : (
          <div className={cx('text', 'shrinked-component')}>{content}</div>
        )}
      </div>
    </div>
  );
};

NoteBlock.propTypes = {
  note: T.shape({
    title: T.string.isRequired
  })
};

const mapSizesToProps = ({ width }) => ({
  isTablet: width <= 1024
});

const enhance = compose(
  connect(
    state => ({
      activeNote: state.journals.activeNote
    }),
    { openModal, setActiveNote }
  ),
  withSizes(mapSizesToProps)
);

export default enhance(NoteBlock);



// WEBPACK FOOTER //
// ./src/containers/Journal/components/NoteBlock.jsx